import { Box, Container, Grid, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <Box
        component="footer"
        sx={{
          bgcolor: 'secondary.dark',
          color: 'common.white',
          py: 6
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {/* Information Section */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                Information
              </Typography>
              <Box component="nav" sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, color: 'text.disabled' }}>
                <Link component={RouterLink} to="/about_us" underline="hover" color="inherit">About Us</Link>
                <Link component={RouterLink} to="/" underline="hover" color="inherit">Delivery Info</Link>
                <Link component={RouterLink} to="/" underline="hover" color="inherit">Privacy Policy</Link>
                <Link component={RouterLink} to="/" underline="hover" color="inherit">Terms & Conditions</Link>
                <Link component={RouterLink} to="/" underline="hover" color="inherit">Site Map</Link>
              </Box>
            </Grid>

            {/* Policy Section */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                Policy & Terms
              </Typography>
              <Box component="nav" sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, color: 'text.disabled' }}>
                <Link component={RouterLink} to="/" underline="hover" color="inherit">Terms of Use</Link>
                <Link component={RouterLink} to="/" underline="hover" color="inherit">Disclaimer</Link>
                <Link component={RouterLink} to="/" underline="hover" color="inherit">Tradology</Link>
                <Link component={RouterLink} to="/how-to-pay" underline="hover" color="inherit">How to Pay</Link>
                <Link component={RouterLink} to="/credit-account" underline="hover" color="inherit">Credit Account Form</Link>
              </Box>
            </Grid>

            {/* Contact Section */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                Get in Touch
              </Typography>
              <Typography sx={{ py: 2 }}>
                MM ,a standard of FiatCo initiative
              </Typography>
              <Box sx={{ color: 'text.disabled' }}>
                Registered Office
                <br />
                Will be updated
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{ bgcolor: 'secondary.main', p: 3, color: 'white', textAlign: 'center' }}>
        {/* <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
            Concept designed and maintained by - TDS (the_digital_salon)
          </Typography> */}
        <Typography variant="body2">
          © 2025 All rights reserved by MM, a standard of FiatCo initiative
        </Typography>
      </Box>
    </>
  );
};

export default Footer;